export default "__VITE_ASSET__CGk2FvNw__"